import { ReactNode } from "react";

interface ImageHeaderProps {
  title: string;
  imageSrc: string;
  right?: ReactNode;
  className?: string;
}


/**
 * Banner-style section header with a photo background and overlaid title.
 * Used on the dashboard to introduce sections in an enticing, image-led way
 * without sectioning the page off with hard dividers.
 */
export default function ImageHeader({
  title,
  right,
  className = "",
}: ImageHeaderProps) {
  return (
    <div
      className={`relative rounded-xl overflow-hidden ${className}`}
    >
      {/* <img
        src={imageSrc}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover scale-105"
      /> */}
      {/* <div className="absolute inset-0 bg-gradient-to-r from-white/85 via-white/60 to-white/40 dark:from-black/85 dark:via-black/60 dark:to-black/40" /> */}
      <div className="relative h-full flex items-end justify-between gap-4 py-2">
        <h2 className="text-2xl md:text-3xl font-bold text-black drop-shadow-sm dark:text-white">
          {title}
        </h2>
        {right && <div className="shrink-0">{right}</div>}
      </div>
    </div>
  );
}
